export enum profileListEnum {
    SYSADMIN = 1,
    USER = 2,
    SUPERADMIN = 3,
    ADMIN = 4,
    SIGNER = 5,
    CONFIGURATOR = 6
}
